module.exports = __webpack_public_path__ + "img/pancake-hero-mobile.615e93ee.png";